/**
 * Function to map BE useCase tags into FE useCase names
 */
export const nameUseCase = (useCase: string): string => {
  return useCase.replace(/_/g, ' ').replace('Device', 'eSIM');
};
